import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";

/**
 * Get the status of a background job
 * @param {string} jobId - The ID of the job to query
 * @returns {Promise<object>} Job status response
 */
export const getJobStatus = async (jobId) => {
	try {
		let response = await API.get(`${Apis.Jobs}/${jobId}/status`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
